<template>
  <div class="card card-product shadow br">
    <img
      :src="require(`../assets/images/${product.gambar}`)"
      class="card-img-top brt"
      alt="image-best-product"
    />
    <div class="card-body">
      <h5 class="card-title">
        <strong>{{ product.nama }}</strong>
      </h5>
      <p class="card-text">
        <strong>Rp. {{ formatPrice(product.harga) }}</strong>
      </p>
      <router-link class="btn btn-block btn-success" :to="/foods/ + product.id">
        <b-icon icon="cart"></b-icon> Pesan
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardProduct",
  props: ["product"],
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style scope>
.card-product {
  min-height: 300px;
}

.card-img-top {
  max-height: 200px;
}

.br {
  border-radius: 15px;
}

.brt {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
</style>
